import React from 'react';
import styled from 'styled-components';

import { Text } from 'grommet';

import AnimatedEllipsis from 'app/components/AnimatedEllipsis';

const ResponsiveText = styled(Text)`
  font-size: 20px;
  line-height: 28px;
  @media (max-width: 600px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

function AwaitingSelectionNotification({ selection = 'selection' }) {
  return (
    <ResponsiveText
      weight="bold"
      color="accent-1"
    >
      {`Awaiting ${selection}`} <AnimatedEllipsis />
    </ResponsiveText>
  );
}

export default AwaitingSelectionNotification;



// WEBPACK FOOTER //
// ./src/app/components/BookmarkMenu/AwaitingSelectionNotification.js